/* eslint-disable
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import * as navigation from 'Navigation';

const {DOM: rd} = React;

class EmptyEntryTabState extends navigation.TabState {
  defaults() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'No Protocols',
      closeable: false,
      options: false,
      showInNavBar: false,
      preferenceKey: 'empty-entry',
    });
  }
}

class EmptyEntryTabView extends Backbone.View {
  static initClass() {
    this.prototype.className = 'buffer-tab';
  }

  render() {
    this.$el
      .empty()
      .append($('<div>').addClass('buffer-tab-emptyEntryText').text('The entry has no protocols.'));
    return this;
  }
}
EmptyEntryTabView.initClass();

export const EmptyEntryOptionsView = null;
export {EmptyEntryTabView, EmptyEntryTabState};
